import { ActionType } from "@sp-crm/core";
import { WhiteLabelContentMode } from "generated/graphql";
import { useProductBranding, useWhiteLabelContentMode } from "store/selectors/branding";
import { useIsAllowed } from "store/selectors/hooks";
import { useLeadSourcesSettingsLocation } from "./use-lead-sources-settings-location";

export type OfficeLeadSourcesVisibility = "loading" | "shown" | "hidden";

export const useOfficeLeadSourcesVisibility = (): OfficeLeadSourcesVisibility => {
    const leadSourcesLocation = useLeadSourcesSettingsLocation();
    const canViewLeadSources = useIsAllowed(ActionType.ViewInboundLeadSources);
    const isFullBrandContent = useWhiteLabelContentMode() === WhiteLabelContentMode.Full;
    const productBranding = useProductBranding();

    if (leadSourcesLocation === "loading" || productBranding.isLoading) {
        return "loading";
    }
    return leadSourcesLocation === "office" && canViewLeadSources && isFullBrandContent
        ? "shown"
        : "hidden";
};
